module.exports = __webpack_public_path__ + "370d87f7f1d437950496feac9817f8f8.pdf";